// extracted by mini-css-extract-plugin
export var dropdown = "cart-dropdown-module--dropdown--cc484";
export var emptyCartInfo = "cart-dropdown-module--empty-cart-info--5eb5a";
export var link = "cart-dropdown-module--link--5bd2a";
export var loader = "cart-dropdown-module--loader--0be60";
export var moreItems = "cart-dropdown-module--more-items--ca81a";
export var moreItemsText = "cart-dropdown-module--more-items-text--43b87";
export var separator = "cart-dropdown-module--separator--f06e3";
export var title = "cart-dropdown-module--title--031e7";